import React, { useMemo } from 'react';
import Button from '@msi/cobalt-react/button';
import Icon from '@msi/cobalt-react/icon';
import { Modal, ModalHeader, ModalContent, ModalActions } from '@msi/cobalt-react/modal';
import './GetUpdatesModal.css';

interface GetUpdatesModalProps {
    isOpen: boolean;
    email: string;
    helperText: string;
    isSubmitting?: boolean;
    onEmailChange: (value: string) => void;
    onClearEmail: () => void;
    onSubscribe: () => void;
    onCancel: () => void;
    selectedCount?: number;
}

const GetUpdatesModal: React.FC<GetUpdatesModalProps> = ({
    isOpen,
    email,
    helperText,
    isSubmitting = false,
    onEmailChange,
    onClearEmail,
    onSubscribe,
    onCancel,
    selectedCount,
}) => {
    const modalStyle = useMemo(() => ({
        overlay: {
            zIndex: 4000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '24px',
        },
        content: {
            zIndex: 4001,
            inset: 'auto',
            position: 'relative',
            border: 'none',
            padding: 0,
            overflow: 'visible',
            width: 'min(520px, calc(100vw - 48px))',
            maxWidth: '520px',
            margin: '0 auto',
            background: 'transparent',
        },
    }), []);
    const disableSubscribe = !email.trim() || isSubmitting;
    const modalContent = (
        <Modal handleCloseModal={onCancel} showModal={isOpen} style={modalStyle}>
            <div className="get-updates-modal">
            <ModalHeader>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span>Get Updates</span>
                    {selectedCount && selectedCount > 1 && (
                        <span className="get-updates-pill">{selectedCount} APIs</span>
                    )}
                </div>
            </ModalHeader>
            <ModalContent>
                <div className="get-updates-modal-body">
                    <label className="get-updates-field-label" htmlFor="get-updates-email-input">
                        Email
                    </label>
                    <div className="get-updates-input-wrapper">
                        <input
                            id="get-updates-email-input"
                            type="email"
                            value={email}
                            onChange={(event) => onEmailChange(event.target.value)}
                            placeholder="name@motorolasolutions.com"
                            disabled={isSubmitting}
                        />
                        {email && (
                            <button
                                type="button"
                                className="get-updates-input-clear"
                                onClick={onClearEmail}
                                aria-label="Clear email"
                                disabled={isSubmitting}
                            >
                                <Icon name="ic_remove" size={16} />
                            </button>
                        )}
                    </div>
                    <p className="get-updates-helper">{helperText}</p>
                </div>
            </ModalContent>
            <ModalActions>
                <Button
                    text="Cancel"
                    onClick={onCancel}
                    disabled={isSubmitting}
                />
                <Button
                    text={isSubmitting ? 'Subscribing...' : 'Subscribe'}
                    onClick={onSubscribe}
                    variant="primary"
                    disabled={disableSubscribe}
                />
            </ModalActions>
            </div>
        </Modal>
    );
    return modalContent;
};

export default GetUpdatesModal;
